<template>
    <div :class="{'element': true, 'error': errors.has(label), 'focused':focused, 'required': required && required.indexOf('required') > -1 }">
        <label  :class="{'float': true, 'active': active}" :for="label">{{ label }}</label>
        <textarea v-validate="required" :data-vv-scope="scope" v-model="value" :id="label" :name="label" :placeholder="label" @focus="focused = true" @blur="focused = false"></textarea>
        <span v-show="errors.has(scope+'.'+label)" class="error">{{ errors.first(scope+'.'+label) }}</span>
    </div>
</template>
<script type='text/babel'>
    import element from '../../element'

    export default {
        mixins: [element],
    };
</script>